import { ADD_DONATION_ITEM, DONATION_ITEMS, GET_CART, HANDLE_ALT_NUM, HANDLE_SPECIAL_INPUT, RESET_CUS_DONATION, UPDATE_DONATION_ITEM } from "./cartTypes";
import Api from '../../Components/Api';
import { toast } from "react-toastify";
var CryptoJS = require("crypto-js");
const isJsonString = (str: any) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}
export const getCart = (cart?: any) => {
    return async (dispatch: any) => {
        try {
            if (cart === null || cart.length <= 0) {
                cart = [];
            }
            if (cart.length > 0) {
                dispatch({
                    type: GET_CART,
                    payload: cart,
                });
            } else {
                dispatch({
                    type: GET_CART,
                    payload: [],
                });
            }
        } catch (err: any) {
            dispatch({
                type: GET_CART,
                payload: [],
            });
        }
    };
};

export function addDonationToCart(donation: any) {
    return (dispatch: any, getState: any) => {
        let donationStateItems = getState().cart?.donationItems || [];
        let donationItem = donationStateItems.find((item: any) => item.donation_id === donation.donation_id);
        if (!donationItem) {
            dispatch({
                type: ADD_DONATION_ITEM,
                payload: donation,
            });
        }
        else {
            dispatch({
                type: UPDATE_DONATION_ITEM,
                payload: donation,
            })
        }
    }
}

export function deleteDonationFromCart(donation_id: number) {
    return async (dispatch: any, getState: any) => {
        const donationItems = getState().cart.donationItems;
        const updatedDonationItems = donationItems.filter((item: any) => item.donation_id !== donation_id);
        dispatch({
            type: DONATION_ITEMS,
            payload: updatedDonationItems,
        });
    }
}

export const resetCustomerDonation = () => {
  return {
    type: RESET_CUS_DONATION
  };
}

export const saveCart = (cart: any) => {
    //type of cart is array
    return async (dispatch: any) => {
        //convert cart to string
        if (cart === null || cart.length <= 0) {
            cart = [];
        }
        if (cart.length > 0) {
            dispatch({
                type: GET_CART,
                payload: cart,
            });
        } else {
            dispatch({
                type: GET_CART,
                payload: [],
            });
        }
    };
};

export const handleSpecialInstruction = (event: any) => {
    let inst: any = "";
    if (!event?.target) {
        inst = event !== null ? event : ""
    } else {
        if (event.target) {
            inst = event.target.value;
        }
    }
    return {
        type: HANDLE_SPECIAL_INPUT,
        input: inst
    }
}

export const handleAlternateNumber = (event: any) => {
    let inst: any = "";
    if (!event?.target) {
        inst = event !== null ? event : ""
    } else {
        if (event.target) {
            inst = event.target.value;
        }
    }
    return {
        type: HANDLE_ALT_NUM,
        input: inst
    }
}